import { Link, Typography } from "@mui/material";
import { useOmnisearchStore } from "hooks/omnisearch-v2";
import { useTenant } from "hooks/useTenant";
import { Link as RouterLink } from "react-router-dom";
import {
  periodFromSearch,
  periodSearch,
} from "routes/Customer/Waste/Invoices/invoiceTrackingPeriod";
import { NO_VALUE } from "routes/Customer/Waste/Invoices/utils";

type InvoiceLine = { invoiceId: string; invoiceNumber?: string | null };

/** Open the result's invoices with the selected date range intact. */
export function InvoiceLinks({ lines }: { lines: readonly InvoiceLine[] }) {
  const { tenantId } = useTenant();
  const { omnisearch } = useOmnisearchStore();
  const search = periodSearch(periodFromSearch(omnisearch));
  const invoices = new Map<string, string>();
  for (const line of lines) {
    if (line.invoiceNumber != null) invoices.set(line.invoiceId, line.invoiceNumber);
  }
  if (invoices.size === 0 || !tenantId) return <>{NO_VALUE}</>;

  return (
    <Typography variant="body2" component="span" sx={{ whiteSpace: "normal" }}>
      {[...invoices].map(([invoiceId, number], index) => (
        <span key={invoiceId}>
          {index > 0 ? ", " : ""}
          <Link
            component={RouterLink}
            to={`/o/${tenantId}/waste/invoices/${invoiceId}${search}`}
            onClick={(event) => event.stopPropagation()}
          >
            {number}
          </Link>
        </span>
      ))}
    </Typography>
  );
}
